// 取件二维码
<template>
  <div class="pickupQRcode">
    <p class="text">请使用微信扫描下方的二维码进行取件</p>
      <span
        class="text"
        v-show="QRurl === ''">二维码获取中...</span>
        <img
          :src="QRurl"
          v-show="QRurl !== ''" />
  </div>
</template>

<script>
export default {
  name: 'pickupQRcode',
  data () {
    return {
      QRurl: '',
      getQRcodeInterval: {}
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
  },
  watch: {
  }
}
</script>

<style scoped>
  .pickupQRcode{
    width: 100%;
    color: #ffffff;
    text-align: center;
    height: 5rem;
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
  }

  .pickupQRcode .text{
    font-size: 0.34rem
  }

  .pickupQRcode img{
    margin-top: 0.5rem;
    width: 4rem;
    height: 4rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/turnoverCabinet/pickupQRcode.vue